import { DataService } from 'src/app/services/data.service';
import { Material } from './../../../../interfaces/course';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.scss']
})
export class MaterialsComponent implements OnInit {

  materials: Material[];

  currentPage = 1;
  totalItemsPerPage = 20;

  constructor(
    private data: DataService
  ) { }

  ngOnInit() {
    this.getData();
  }

  getData(){
    this.data.getMaterials().subscribe((res) => {
      if(res && res.data){
        this.materials = res.data;
      }
    })
  }

  async delete(id){
    await this.data.deleteMaterial(id);
    this.getData();
  }
}
